<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- Pilihan Serial Number -->
          <text-input v-model="form.serial_number" :error="form.errors.serial_number" type="text" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Serial Number')" :required="true" />

          <!-- Tampilkan Type, Brand, dan Category -->
          <select-input v-model="form.type_assets_id" :required="true" @change="updateChange" :error="form.errors.type_assets_id" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Type')">
            <option :value="null">{{ __('Select Type') }}</option>
            <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
          </select-input>

          <text-input v-model="form.brand" :error="form.errors.brand" type="text" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Brand')" readonly />
          <text-input v-model="form.category" :error="form.errors.category" type="text" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Category')" readonly />

          <!-- Join Date -->
          <text-input v-model="form.join_date" :error="form.errors.join_date" type="date" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Join Date')" />

          <!-- Specification -->
          <textarea-input v-model="form.specification" :error="form.errors.specification" :rows="8" class="pb-6 w-full lg:w-1/2" placeholder="specification here..." :label="__('Specification')"></textarea-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

    <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
    Head,
    SelectInput,
  },
  layout: Layout,
  props: {
    title: String,
    asset: Object,
    types: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        type: this.asset.type,
        serial_number: this.asset.serial_number,
        brand: this.asset.brand,
        join_date: this.asset.join_date,
        category: this.asset.category,
        specification: this.asset.specification,
        type_assets_id: this.asset.type_assets_id,
      }),
    }
    //   console.log(this.access)
  },
  methods: {
    updateChange() {
      const selectedType = this.types.find((t) => t.id === this.form.type_assets_id)
      if (selectedType) {
        this.form.category = selectedType.category || ''
        this.form.brand = selectedType.brand || ''
      } else {
        this.form.category = ''
        this.form.brand = ''
      }
    },
    update() {
      this.form.put(this.route('assets.update', this.asset.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this asset?')) {
        this.$inertia.delete(this.route('assets.destroy', this.asset.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this asset?')) {
        this.$inertia.put(this.route('assets.restore', this.asset.id))
      }
    },
  },
}
</script>
